var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(-570 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(-312)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 70,
    height: 61,
    rx: 24,
    transform: "translate(882 573)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_104_1",
    "data-name": "Component 104 \\u2013 1",
    transform: "translate(908.69 595.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add",
    d: "M23.619,15.31a1.662,1.662,0,0,1-1.662,1.662H16.971v4.986a1.662,1.662,0,1,1-3.324,0V16.971H8.662a1.662,1.662,0,1,1,0-3.324h4.986V8.662a1.662,1.662,0,1,1,3.324,0v4.986h4.986A1.662,1.662,0,0,1,23.619,15.31Z",
    transform: "translate(-7 -7)",
    fill: "#716c6c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdNew);
export default __webpack_public_path__ + "static/media/prodNew.4a0ee71da5789ca129cccb1213abe7bc.svg";
export { ForwardRef as ReactComponent };